import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { Home, BarChart, Edit } from '@mui/icons-material';
import { colors } from '../../theme';

const BarberBottomNav = ({ shopId, barberId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const path     = location.pathname;

    const isMain  = path === `/barber/${shopId}/${barberId}/dashboard`;
    const isStats = path === `/barber/${shopId}/${barberId}/stats`;
    const isEdit  = path === `/barber/${shopId}/${barberId}/edit`;

    const NAV = [
        { label: 'Main',  icon: <Home sx={{ fontSize: 20 }} />,    active: isMain,  onClick: () => navigate(`/barber/${shopId}/${barberId}/dashboard`) },
        { label: 'Stats', icon: <BarChart sx={{ fontSize: 20 }} />, active: isStats, onClick: () => navigate(`/barber/${shopId}/${barberId}/stats`) },
        { label: 'Edit',  icon: <Edit sx={{ fontSize: 20 }} />,     active: isEdit,  onClick: () => navigate(`/barber/${shopId}/${barberId}/edit`) },
    ];

    return (
        <Box sx={{
            position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100,
            bgcolor: colors.bgTopBar, borderTop: `1px solid ${colors.border}`,
            px: 3, py: 1.5,
            display: 'flex', justifyContent: 'space-around', alignItems: 'center',
        }}>
            {NAV.map(item => (
                <Box key={item.label} onClick={item.onClick} sx={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.3,
                    cursor: 'pointer', flex: 1,
                    transition: 'opacity .2s',
                }}>
                    <Box sx={{ color: item.active ? colors.primary : colors.textMuted }}>{item.icon}</Box>
                    <Typography sx={{ fontSize: 10, color: item.active ? colors.primary : colors.textMuted, fontWeight: item.active ? 700 : 400 }}>
                        {item.label}
                    </Typography>
                    {item.active && (
                        <Box sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: colors.primary, mt: 0.2 }} />
                    )}
                </Box>
            ))}
        </Box>
    );
};

export default BarberBottomNav;